var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4875_48197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 102C79.1665 102 102 79.1665 102 51C102 22.8335 79.1665 0 51 0C22.8335 0 0 22.8335 0 51C0 79.1665 22.8335 102 51 102Z",
    fill: "#1F82FF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6464 37H65.5627C65.1303 37 64.72 37.1957 64.4553 37.5306L46.2664 60.2445L37.5447 49.3507C37.4127 49.1856 37.2445 49.052 37.0528 48.9602C36.861 48.8683 36.6506 48.8204 36.4373 48.8201H33.3536C33.0581 48.8201 32.8948 49.155 33.0757 49.3811L45.1591 64.4716C45.7237 65.1761 46.809 65.1761 47.3781 64.4716L68.9243 37.5567C69.1052 37.3349 68.9419 37 68.6464 37Z",
    fill: "#1F82FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4875_48197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7b367932c3bb45ec26f8340250d2a52f.svg";
export { ForwardRef as ReactComponent };